export const TABLE_STATUS = {
    PASSED: 'Passed',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    ABORTED: 'Aborted',
    IN_PROGRESS: 'InProgress',
} as const;

export type Statuses = (typeof TABLE_STATUS)[keyof typeof TABLE_STATUS];

export const STATUS_TYPE = {
    SUCCESS: 'success',
    FAILURE: 'failure',
    IN_PROGRESS: 'inProgress',
} as const;

export type StatusType = (typeof STATUS_TYPE)[keyof typeof STATUS_TYPE];

export const STATUS_TO_TYPE = [
    { status: TABLE_STATUS.PASSED, type: STATUS_TYPE.SUCCESS },
    { status: TABLE_STATUS.COMPLETED, type: STATUS_TYPE.SUCCESS },
    { status: TABLE_STATUS.FAILED, type: STATUS_TYPE.FAILURE },
    { status: TABLE_STATUS.ABORTED, type: STATUS_TYPE.FAILURE },
] as const;
